/**
 * Enum defining the possible reasons for no sites being available
 * Used in the redirect to no-sites page to display appropriate messaging
 */
export enum NoSitesReason {
  GEOGRAPHIC = "geographic",
  DISQUALIFIED = "disqualified",
  AGE_INELIGIBLE = "age_ineligible",
}

/**
 * Check if a given string is a valid NoSitesReason value
 */
export function isValidNoSitesReason(reason: string): reason is NoSitesReason {
  return Object.values(NoSitesReason).includes(reason as NoSitesReason);
}

/**
 * Get a default message for a no-sites reason
 */
export function getDefaultNoSitesMessage(reason: NoSitesReason): string {
  switch (reason) {
    case NoSitesReason.AGE_INELIGIBLE:
      return "Based on your age, you don't meet the eligibility requirements for this study.";
    case NoSitesReason.DISQUALIFIED:
      return "Based on your responses, you don't meet the eligibility requirements for this study.";
    case NoSitesReason.GEOGRAPHIC:
      return "There are no clinical trial sites available in your area for this study.";
    default:
      return "No clinical trial sites are available for this study.";
  }
}
